import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=57458d03&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"
import style0 from "./logistics.vue?vue&type=style&index=0&id=57458d03&scoped=true&lang=scss"
import style1 from "./logistics.vue?vue&type=style&index=1&id=57458d03&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57458d03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57458d03')) {
      api.createRecord('57458d03', component.options)
    } else {
      api.reload('57458d03', component.options)
    }
    module.hot.accept("./logistics.vue?vue&type=template&id=57458d03&scoped=true", function () {
      api.rerender('57458d03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/softBusinessLogistics/logistics.vue"
export default component.exports